/**
 * ModuleName
 *
 * ModuleDescription
 *
 * @return {type}
 */

OT.createNS('OT.Common.Helpers.getRequestId');

OT.Common.Helpers.getRequestId = (function () {
    'use strict';

    return function () {
        try {
            return OT.Search.Data.get().Headers.RequestId;
        } catch (error) {
            return OT.Common.Helpers.generateGUID();
        }
    };
})();